import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
  deleteDoc,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { Business } from "@visitproof/types";
import { db } from "../firebase";
import { clean } from "../utils/utils";

const businessCollectionRef = collection(db, "businesses");

export const BusinessService = {
  async createBusiness(
    businessData: Omit<Business, "id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const newBusiness: Omit<Business, "id"> = {
      ...businessData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };

    const businessRef = await addDoc(businessCollectionRef, newBusiness);
    return businessRef.id;
  },

  async getBusiness(businessId: string): Promise<Business | null> {
    try {
      const businessDoc = await getDoc(doc(businessCollectionRef, businessId));
      if (businessDoc.exists()) {
        return { id: businessDoc.id, ...businessDoc.data() } as Business;
      }
    } catch (e) {
      console.error("Error getting business:", e);
    }
    return null;
  },

  async getAllBusinesss(accountId: string): Promise<Business[]> {
    const businessSnapshot = await getDocs(
      query(businessCollectionRef, where("accountId", "==", accountId)),
    );
    return businessSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as Business,
    );
  },

  async updateBusiness(
    businessId: string,
    updatedData: Partial<Omit<Business, "id" | "createdAt">>,
  ): Promise<void> {
    const businessDocRef = doc(businessCollectionRef, businessId);
    await updateDoc(businessDocRef, clean({
      ...updatedData,
      updatedAt: Timestamp.now(),
    }));
  },

  async deleteBusiness(businessId: string): Promise<void> {
    const businessDocRef = doc(businessCollectionRef, businessId);
    await deleteDoc(businessDocRef);
  },
};
